<template>
    <div>
        <section class="xlrclh">
            <img class="top-img" src="./../assets/imgs/113/title-bg.png" alt="" />
            <div class="technological-process">
                <div class="sxcl">
                    <img class="top" src="./../assets/imgs/113/title-1.png" alt="" />
                    <div class="content" style="text-align: center;">
                        邛崃市非公有制企业及非公有制企业人才。
                    </div>
                </div>
                <div class="svcl">
                    <img class="top" src="./../assets/imgs/113/title-2.png" alt="" />
                    <div class="content">
                        <div style="font-size: 0.3rem; font-weight: 600">
                             申报对象分为人才和企业，须分别符合以下条件。
                        </div>
                        <div style="
                                                font-size: 0.28rem;
                                                font-weight: 600;
                                                margin-top: 0.25rem;
                                                display: flex;
                                                align-items: center;
                                            ">
                            <span class="hollow-cricle" style="margin-right: 0;"></span>（一）申报人才须同时满足以下基本条件:
                        </div>
                        <div class="des" style="padding-top: 0.15rem;padding-bottom: 0.15rem;">
                            <div>
                                1. 须全职在邛崃工作，社保缴纳关系在邛崃；
                            </div>
                            <div>
                                2. 在邛工作单位为邛崃市非公有制企业；
                            </div>
                            <div>
                                3. 在邛连续工作满12个月（其中，新引进的人才须同时满足在邛工作时间不超过36个月），与企业签订连续不少于3年的劳动合同； 
                            </div>
                            <div>
                                4. 未达到法定退休年龄且未提前退休。
                            </div>
                            <div>
                                5. 不存在违法犯罪、偷税、逃税、漏税等其他影响个人申报的前科劣迹情况。
                            </div>
                        </div>
                        <div style="
                                                font-size: 0.28rem;
                                                font-weight: 600;
                                                margin-top: 0.25rem;
                                                display: flex;
                                                align-items: center;
                                            ">
                            <span class="hollow-cricle" style="margin-right: 0;"></span
                                >（二）申报企业须同时满足以下基本条件:
                        </div>
                        <div class="des" style="padding-top: 0.15rem;padding-bottom: 0.15rem;">
                         <div>1. 在邛崃市内依法登记、具有独立法人资格、税收解缴和统计关系均在邛崃的非公有制企业。</div>
                         <div>2. 遵纪守法，诚信经营，未发生重大安全事故和环境污染事故，不存在偷、逃、漏税等其他影响企业申报的前科劣迹情况。</div>
                        </div>
                    </div>
                </div>
                <div class="zccl">
                    <img class="top" src="./../assets/imgs/113/title-3.png" alt="" />
                    <div class="content">
                        <div class="des" style="text-align: left;">
                            <span class="title">人才“凤栖奖”</span>
                            <div class="dotCom">
                                <div class="dot">1</div>
                                对企业新引进的全日制博士研究生、全日制硕士研究生，5年内分别给予每人每年5万元、2万元生活补贴。
                            </div>
                            <div class="dotCom">
                                <div class="dot">2</div>
                                对企业新引进或新获评的正高级、副高级专业技术职称人才，5年内分别给予每人每年5万元、2万元生活补贴。
                            </div>
                            <div class="dotCom">
                                <div class="dot">3</div>
                                对新获得世界技能大赛奖项的选手，给予最高50万元一次性奖励；对新获得全国职业技能大赛奖项的选手，给予最高10万元一次性奖励；对新获得省级职业技能大赛奖项的选手，给予最高3万元一次性奖励；对新获得成都市职业技能大赛奖项的选手，给予最高2万元一次性奖励。
                            </div>
                            <div class="dotCom">
                                <div class="dot">4</div>
                                对新获得“中华技能大奖”“全国技术能手”等相当级别称号的给予10万元一次性奖励；对新获得 “四川省技术能手”及相当级别称号的给予3万元一次性奖励。
                            </div>
                            <div class="dotCom">
                                <div class="dot">5</div>
                                对新引进到在邛博士后科研工作站、科研流动站、创新实践基地的博士后人才，每人每年给予10万元生活资助，资助期2年；出站后留邛工作的博士后人才再给予10万元资助。
                            </div>
                            <div class="dotCom">
                                <div class="dot">6</div>
                                对符合成都市人才落户条件的青年人才，首次落户邛崃且在邛就业或自主创业的，落户满一年后给予每人5000元一次性奖励。
                            </div>
                        </div>
                        <div class="des" style="text-align: left;">
                            <div class="title">企业“伯乐奖”</div>
                            <div class="dotCom"><div class="dot">1</div>对在高校院所、职业院校设立奖学金的企业，按到岗青年（大学生）人才实际获得奖学金总额的30%，给予企业一次性奖励，每个企业每年不超过50万元。</div>
                            <div class="dotCom"><div class="dot">2</div>对企业通过冠名班、订单班与高校院所、职业院校合作开展人才培养的，每实际培养到岗1人，给予企业5000元的一次性奖励，每个企业每年不超过10万元。</div>
                            <div class="dotCom"><div class="dot">3</div>对举荐高层次人才来邛创办企业或与邛崃市企业签订连续3年以上劳动合同（服务协议），且每年实际在邛工作时间不少于9个月（创业人才不少于6个月）的，每成功举荐1人，给予举荐方最高50万元一次性奖励。</div>
                            <div class="dotCom"><div class="dot">4</div>对年度税收贡献、带动就业增长、人才平台建设、引育人才等方面效果显著的企业，给予最高10万元一次性奖励。</div>
                            <div class="dotCom"><div class="dot">5</div>对举办具有行业影响力品牌赛事、展会、论坛的企业，每项活动给予最高30万元一次性奖励。</div>
                        </div>
                        <div class="des" style="text-align: left;">
                            <div class="title">企业“育才奖”</div>
                            <div class="dotCom"><div class="dot">1</div>对企业积极推荐在职人员申报国家海外高层次人才引进计划、国家高层次人才特殊支持计划、省“天府峨眉计划”、省“天府青城计划”、成都市“蓉漂计划”并成功入选的，给予最高50万元奖励。对推荐人员入围答辩环节但未成功入选的企业，给予最高30万元奖励。</div>
                            <div class="dotCom"><div class="dot">2</div>对企业每出资培养1名硕士研究生及以上学历员工的，按企业出资学费的20%给予企业一次性奖励，每个企业每年不超过10万元。</div>
                            <div class="dotCom"><div class="dot">3</div>对企业每新晋升1名正高级、副高级专业技术人才的，分别给予企业1万元、5000元一次性奖励。</div>
                            <div class="dotCom"><div class="dot">4</div>对企业每新培养1名全国技术能手、四川省技术能手或相当级别的高技能人才的，分别给予企业5万元、3万元一次性奖励。</div>
                            <div class="dotCom"><div class="dot">5</div>对企业新获得认定的博士后科研工作站、科研流动站、创新实践基地，给予30万元资助。对新获得认定的技能大师工作室、首席技师工作室、劳模和工匠人才创新工作室等技术技能平台，给予企业最高10万元资助。</div>
                            <div class="dotCom"><div class="dot">6</div>对新获得认定的院士（专家）工作站、产学研联合实验室、产业（技术）创新中心、工程实验室、工程（技术）研究中心、企业技术中心等技术开发平台，给予企业最高100万元资助。</div>
                        </div>

                    </div>
                </div>
                <div class="sbcl">
                    <img class="top" src="./../assets/imgs/113/title-4.png" alt="" />
                    <div class="content">
                        <div class="des">
                            <div class="item">
                                <div class="line"></div>
                                <div class="dot">1</div>
                                印发申报通知
                            </div>
                            <div class="item">
                                <div class="line"></div>
                                <div class="dot">2</div>
                                凤栖奖、伯乐奖、育才奖
                            </div>
                            <div class="item">
                                <div class="line"></div>
                                <div class="dot">3</div>
                                行业主管部门、产业功能区管理机构初审
                            </div>
                            <div class="item">
                                <div class="line"></div>
                                <div class="dot">4</div>
                                奖项主管部门复审
                            </div>
                            <div class="item">
                                <div class="line"></div>
                                <div class="dot">5</div>
                                市委人才办会同相关部门联合审查
                            </div>
                            <div class="item">
                                <div class="line"></div>
                                <div class="dot">6</div>
                                审定
                            </div>
                            <div class="item">
                                <div class="dot">7</div>
                                兑现奖励
                            </div>
                        </div>

                    </div>
                </div>
                <div class="sxcl">
                    <img class="top" src="./../assets/imgs/113/title-5.png" alt="" />
                    <div class="content" style="font-weight: bold;font-size:0.3rem ;">
                        依据每年度通知时间确定
                    </div>
                </div>
                <div class="contact">
                    <img class="top" src="./../assets/imgs/113/title-6.png" alt="" />
                    <div class="content">
                        <div class="number">
                            <span class="label">政策咨询电话：</span>
                            <div>
                                <a href="tel:028-88792130">028-88792130</a>
                            </div>
                        </div>
                        <div class="unit">
                            <span class="label">责任单位：</span>
                            邛崃市委人才办
                        </div>
                    </div>
                </div>
                <div class="codes">
                    <img class="code" src="../assets/imgs/113/code.png" />
                    <img class="text" src="../assets/imgs/113/text.png" />
                </div>
            </div>
        </section>
        <!-- <call phone="028-83221725"></call> -->
    </div>
</template>

<script>
import call from "../components/call.vue";
export default {
    data() {
        return {};
    },

    components: {
        call,
    },

    mounted() { },

    methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";

.xlrclh {
    background-color: $base-back;

    .top-img {
        width: 7.26rem;
        height: 5.6rem;
    }

    .technological-process {
        transform: translateY(-1.9rem);

        .sxcl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #fff;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;
                line-height: 0.44rem;
            }
        }
        .svcl {
            position: relative;
            margin-top: 0.22rem;
            line-height: 0.44rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.35rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;

                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.35rem 0.23rem 0.3rem;
                    margin-top: 0.2rem;
                    position: relative;

                    .title {
                        font-size: 0.3rem;
                        font-weight: bold;
                        color: #333333;
                    }

                    .item {
                        margin-top: 0.22rem;
                        box-sizing: border-box;
                        position: relative;
                        padding-left: 0.42rem;
                        display: flex;
                        font-weight: bold;
                        .dot {
                            width: 0.39rem;
                            height: 0.39rem;
                            background-color: #739bfe;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            font-size: 0.28rem;
                            color: #fff;
                            border-radius: 50%;
                            position: absolute;
                            left: -0.1rem;
                            top: 0;
                            z-index: 9999;
                        }
                    }
                }
            }
        }
        .zccl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.35rem 0.23rem 0.3rem;
                    margin-top: 0.8rem;
                    position: relative;
                    text-align: center;
                    line-height: 0.44rem;

                    .title {
                        position: absolute;
                        top: -0.5rem;
                        left: 50%;
                        transform: translateX(-50%);
                        width: 2.98rem;
                        height: 0.67rem;
                        line-height: 0.67rem;
                        display: flex;
                        justify-content: center;
                        align-content: center;
                        font-size: 0.32rem;
                        font-weight: bold;
                        color: #ffffff;
                        border-radius: 1rem;
                        background-color: #739bfe;
                    }
                    .dotCom{
                        position: relative;
                        text-indent: 0.4rem;
                    }
                    .dot {
                        width: 0.39rem;
                        height: 0.39rem;
                        background-color: #739bfe;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        font-size: 0.28rem;
                        color: #fff;
                        border-radius: 50%;
                        position: absolute;
                        left: -0.1rem;
                        top: 0;
                        text-indent: 0;

                    }
                }
            }
        }

        .sbcl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.35rem 0.23rem 0.3rem;
                    margin-top: 0.35rem;
                    position: relative;



                    .item {
                        margin-top: 0.35rem;
                        box-sizing: border-box;
                        position: relative;
                        padding-left: 0.42rem;
                        display: flex;

                        .line {
                            position: absolute;
                            width: 0.02rem;
                            height: 135%;
                            border-left: 0.02rem dashed #739bfe;
                            left: 0.1rem;
                            top: 0.2rem;
                            z-index: 0;
                            //   background-color: #739bfe;
                        }

                        .dot {
                            width: 0.39rem;
                            height: 0.39rem;
                            background-color: #739bfe;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            font-size: 0.28rem;
                            color: #fff;
                            border-radius: 50%;
                            position: absolute;
                            left: -0.1rem;
                            top: 0;
                            z-index: 9999;
                        }
                    }
                }
            }
        }
        .codes {
            margin: 0 auto;
            margin-top: 0.25rem;
            width: 6.85rem;
            background: #fff;
            padding: 0.3rem;
            box-sizing: border-box;
            border-radius: 0.26rem;
            padding-top: 0.28rem;
            font-size: 0.26rem;
            font-weight: 500;
            color: #4e4e4e;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .code {
                width: 1.94rem;
                height: 1.94rem;
            }

            .text {
                width: 4.5rem;
            }
        }

    }
}
</style>
